import { List } from "@/components/flexkit/list/List";
import { SkeletonBlock } from "@/components/podkit/loading/Skeleton";
import type { FC } from "react";

type AutomationListItemSkeletonProps = {
    id: string;
};

export const AutomationListItemSkeleton: FC<AutomationListItemSkeletonProps> = ({ id }) => {
    return (
        <List.Item id={id}>
            <List.ItemIcon size={40} className="bg-transparent">
                <SkeletonBlock ready={false} className="size-10 rounded-full" />
            </List.ItemIcon>

            <List.ItemTitle>
                <div data-testid="automation-list-item-skeleton" className="flex flex-col gap-2">
                    <div className="flex flex-wrap items-center gap-2">
                        <SkeletonBlock ready={false} className="h-4 w-40 max-w-[60%]" />
                        <SkeletonBlock ready={false} className="h-5 w-16 rounded-full" />
                    </div>
                </div>
            </List.ItemTitle>

            <List.ItemDescription>
                <div className="flex flex-wrap items-center gap-2">
                    <SkeletonBlock ready={false} className="h-4 w-32" />
                    <SkeletonBlock ready={false} className="h-4 w-24" />
                    <SkeletonBlock ready={false} className="h-4 w-20" />
                </div>
            </List.ItemDescription>

            <List.ItemContent alignment="right">
                <div className="flex flex-wrap items-center justify-end gap-2">
                    <SkeletonBlock ready={false} className="h-8 w-12 rounded-md" />
                    <SkeletonBlock ready={false} className="h-8 w-8 rounded-md" />
                </div>
            </List.ItemContent>
        </List.Item>
    );
};
